import { shortDay, type ISODate } from '../../shared/dates';
import { headlineWeight, type HeadlineWeight, type WeightSummary } from '../../shared/trend';

export interface WeightHeadlineCopy {
  shown: HeadlineWeight | null;
  /** "Recent low", "Latest weigh-in", or "Trend weight". */
  title: string;
  /** "14-day low · Nov 2", the weigh-in date, or empty when the number is the trend. */
  detail: string;
}

/** Label for the primary weight: the recent low, with the trend window and its date. */
export function weightHeadlineCopy(summary: WeightSummary | undefined, windowDays: number, today: ISODate): WeightHeadlineCopy {
  const shown = summary ? headlineWeight(summary) : null;
  if (!shown) return { shown: null, title: 'Weight', detail: '' };
  if (shown.source === 'trend') return { shown, title: 'Trend weight', detail: '' };
  if (shown.source === 'latest') {
    return { shown, title: 'Latest weigh-in', detail: shown.date ? shortDay(shown.date, today) : '' };
  }
  return {
    shown,
    title: 'Recent low',
    detail: shown.date ? `${windowDays}-day low · ${shortDay(shown.date, today)}` : '',
  };
}
